import { render, staticRenderFns } from "./BrucitCombinedParts.vue?vue&type=template&id=7d0abc6b&scoped=true"
import script from "./BrucitCombinedParts.vue?vue&type=script&lang=js"
export * from "./BrucitCombinedParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0abc6b",
  null
  
)

export default component.exports